export const SELECT_BIRTHS = 'SELECT_BIRTHS'
export const SELECT_DEATHS = 'SELECT_DEATHS'
export const SELECT_ADOPTIONS = 'SELECT_ADOPTIONS'

export const SELECT_AUDITS_BIRTHS = 'SELECT_AUDITS_BIRTHS '
export const SELECT_AUDITS_DEATHS = 'SELECT_AUDITS_DEATHS'
export const SELECT_AUDITS_ADOPTIONS= 'SELECT_AUDITS_ADOPTIONS'